/**
 * ページングの現在の表示範囲を取得する
 * @param currentPage 現在のページ
 * @param limit 1ページの表示数
 * @param totalCount 全件数
 * @return (X～XX件)の形式の文字列を返す
 */
export function displayPagingRange(
  currentPage: number,
  limit: number,
  totalCount: number
): string {
  //0件の場合はブランク
  if (totalCount <= 0) {
    return "";
  }

  const startNumber: number = currentPage * limit + 1;
  let endNumber: number = startNumber + limit - 1;
  if (endNumber > totalCount) {
    endNumber = totalCount;
  }
  return "(" + startNumber + "～" + endNumber + "件表示)";
}

/**
 * 翌日の日付を取得する
 * @param date 日付(yyyy-mm-dd)
 * @return 翌日の日付(yyyy-mm-dd)
 */
export function getNextDate(date: string): string {
  let nextDateStr = "";
  const nextDate = new Date(date);
  nextDate.setDate(nextDate.getDate() + 1);
  new Date(nextDate);
  nextDateStr =
    nextDate.getFullYear() +
    "-" +
    ("0" + String(Number(nextDate.getMonth()) + 1)).slice(-2) +
    "-" +
    ("0" + nextDate.getDate()).slice(-2);
  return nextDateStr;
}

/**
 * 前日の日付を取得する
 * @param date 日付(yyyy-mm-dd)
 * @return 前日の日付(yyyy-mm-dd)
 */
export function getBeforeDate(date: string): string {
  let beforeDateStr = "";
  const beforeDate = new Date(date);
  beforeDate.setDate(beforeDate.getDate() - 1);
  new Date(beforeDate);
  beforeDateStr =
    beforeDate.getFullYear() +
    "-" +
    ("0" + String(Number(beforeDate.getMonth()) + 1)).slice(-2) +
    "-" +
    ("0" + beforeDate.getDate()).slice(-2);
  return beforeDateStr;
}
